export const SOURCE_REGISTRY_FORM_PARAM = {
  sourceRegistryName: 'sourceRegistryName',
  identifiers: 'identifiers',
  replyToTopic: 'replyToTopic',
  replyTimeout: 'replyTimeOut',
  requestSpecJson: 'requestSpecJson',
  responseSpecJson: 'responseSpecJson'
};

export const SOURCE_REGISTRY_MAXLENGTH = {
  sourceRegistryNameMaxLength: '101',
  identifierMaxLength: '501',
};

export const PATTERN_REGISTRY_FORM_PARAM = {
  patternName: 'patternRegistryName',
  patternType: 'patternType',
  signalSource: 'signalSource',
  eventName: 'eventName',
  author: 'author',
  occurrences: 'occurrences',
  timeToLive: 'timeToLive',
  uniqueId: 'uniqueId',
  fieldDefName: 'fieldDefName',
  fieldDefOperator: 'fieldDefOperator',
  fieldDefValue: 'fieldDefValue',
  fieldDefContentType: 'fieldDefContentType',
  fieldDefConversionPattern: 'fieldDefConversionPattern',
  fieldCondition: 'fieldCondition',
  fieldN: 'fieldN',
  journeyName: 'journeyName'
};

export const PATTERN_FORM_MAXLENGTH = {
  patternNameLength: '101',
  patternTypeLength: '51',
  signalSourceLength: '101',
  eventNameLength: '51',
  authorLength: '51',
  occurrencesLength: '51',
  timeToLiveLength: '51',
  uniqueIDLength: '501',
  fieldDefNameLength: '101',
  fieldDefOperatorLength: '51',
  fieldDefValueLength: '51',
  fieldDefContentTypeLength: '51',
  fieldCondition: '51',
  fieldN: '51',
  journeyNameLength: '201'
};

export const TabNumber = {
  SR: 1,
  PR: 2,
  SER: 3,
  FSR: 4,
  CR: 5,
  STR: 6
};

export const TabPaths = {
  SR: 'source-registry', // do not change to src-registry!!
  PR: 'pattern-registry',
  SER: 'src-event-registry', // SR and SER should not be identical for routing purposes. DO NOT CHANGE to event-source-registry!!
  FSR: 'fsm-state-registry',
  CR: 'connector-registry',
  STR: 'src-topic-registry'
};

export const TOAST_MSG = {
  toast_success: 'success',
  toast_danger: 'danger',
  toast_success_header: 'Creation Successful',
  toast_fail_header: 'Creation Failed',
  toast_success_msg: 'The Source Registry was successfully created',
  toast_fail_msg: 'An error occurred when creating the Source Registry. Please try again.',
  toast_identifier_invalid_msg: 'A Source Registry with these identifiers has already been created',
  toast_success_update: 'Updation Successful',
  toast_success_msg_update: 'The Source Registry has been successfully updated',
  toast_fail_update: 'Updation Failed',
  toast_fail_msg_update: 'An error occurred when updating the Source Registry.',
  pls_try_again: 'Please try again.'
};

export const MODE = {
  ADD: 'ADD',
  EDIT: 'EDIT'
};

export const PATTERN_OCCURRENCE = '1';

const OPERATOR = {
  IS: 'IS',
  NOT: 'NOT',
  LIKE: 'LIKE',
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN'
};

const CONTENT_TYPE_DISPLAY = {
  STRING: 'String',
  INTEGER: 'Integer',
  DOUBLE: 'Double',
  BOOLEAN: 'Boolean'
};

const CONTENT_TYPE_VALUE = {
  STRING: 'String',
  INT: 'Int',
  DOUBLE: 'Double',
  BOOLEAN: 'Boolean'
};

export const CONTENT_TYPE_OPTIONS = [
  { value: CONTENT_TYPE_DISPLAY.STRING, name: CONTENT_TYPE_VALUE.STRING },
  { value: CONTENT_TYPE_DISPLAY.INTEGER, name: CONTENT_TYPE_VALUE.INT },
  { value: CONTENT_TYPE_DISPLAY.DOUBLE, name: CONTENT_TYPE_VALUE.DOUBLE },
  { value: CONTENT_TYPE_DISPLAY.BOOLEAN, name: CONTENT_TYPE_VALUE.BOOLEAN },
];

export const OPERATOR_OPTIONS = [
  { value: OPERATOR.IS, name: OPERATOR.IS },
  { value: OPERATOR.NOT, name: OPERATOR.NOT },
  { value: OPERATOR.LIKE, name: OPERATOR.LIKE },
  { value: OPERATOR.GREATER_THAN, name: OPERATOR.GREATER_THAN },
  { value: OPERATOR.LESS_THAN, name: OPERATOR.LESS_THAN },
];

export const FIELD_CONDITION_OPTIONS = [
  { value: 'ALL', name: 'ALL' },
  { value: 'ANY', name: 'ANY' },
  { value: 'AT_LEAST', name: 'AT_LEAST' },
  { value: 'EXACTLY', name: 'EXACTLY' }
];

export const FIELD_DEF_LIST_CONSTANTS = {
  EXACTLY: 'EXACTLY',
  AT_LEAST: 'AT_LEAST',
  ALL: 'ALL',
  ANY: 'ANY'
};

export const NON_NUMERIC_FC = ['ALL', 'ANY', '']; // array used in apply styling changes

export const REG_STATUS_TYPES = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' }
];

export const STATUS_LIST: string[] = ['ACTIVE', 'INACTIVE'];
export const DEFAULT_PAGE_NUM = 0;

export const ERRORS_SR = {
  noResponse: 'No response',
  statusCode: '409'
};

export const eventVersionExtractor = (value: string) => {
  const [, , third] = value.split(' ');
  return third ? parseInt(third.split(')')[0], 10) : 1;
};
